import React, { type FunctionComponent } from 'react'
import { PageHeader } from '@retailer-platform/shared-components'
import { AggregateStorePerformanceOverviewHeaderBreadcrumbs } from 'domains/aggregate-store-performance/components/header/components/breadcrumbs/AggregateStorePerformanceOverviewHeaderBreadcrumbs'
import BannerSwitchTrigger from 'legacy/components/SelectPartnerWarehouse/BannerSwitchTrigger'

interface AggregateStorePerformanceOverviewHeaderProps {}

export const AggregateStorePerformanceOverviewHeader: FunctionComponent<
  AggregateStorePerformanceOverviewHeaderProps
> = () => (
  <PageHeader
    addBottomPadding
    title={<AggregateStorePerformanceOverviewHeaderBreadcrumbs />}
    actions={<BannerSwitchTrigger />}
  />
)
